import errorSent from "./errors/errorSent";
import { getCookie, getRoistatId } from "./index";

/**
 * Получает информацию об устройстве для логирования
 */
function getDeviceInfo() {
  try {
    return {
      userAgent: navigator?.userAgent || "",
      language: navigator?.language || "",
      platform: navigator?.platform || "",
      screen: {
        width: window.screen?.width || 0,
        height: window.screen?.height || 0,
        availWidth: window.screen?.availWidth || 0,
        availHeight: window.screen?.availHeight || 0,
        pixelDepth: window.screen?.pixelDepth || 0,
      },
      windowSize: {
        innerWidth: window?.innerWidth || 0,
        innerHeight: window?.innerHeight || 0,
      },
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
    };
  } catch (e) {
    console.error("Get device error", e);
    return {};
  }
}

/**
 * Проверяет ответ от API roistat
 */
async function checkRoistatApi(
  projectId: string = "1b5078f8b306085dddfc81ddd27a35f9",
) {
  let roistatApiResponse = null;
  let roistatApiError = null;

  try {
    const protocol =
      window.location.protocol === "https:" ? "https://" : "http://";
    const apiUrl = `${protocol}cloud.roistat.com/api/site/1.0/${projectId}/init?referrer=${encodeURIComponent(window.location.href)}`;

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Accept: "application/json, text/javascript, */*; q=0.01",
      },
    });

    const responseText = await response.text();

    roistatApiResponse = {
      status: response.status,
      statusText: response.statusText,
      ok: response.ok,
      // @ts-ignore
      headers: Object.fromEntries(response.headers.entries()),
      body: responseText,
      bodyLength: responseText.length,
    };
  } catch (error) {
    roistatApiError = {
      message: error instanceof Error ? error.message : String(error),
      name: error instanceof Error ? error.name : "Unknown",
      stack: error instanceof Error ? error.stack : undefined,
    };
  }

  return { roistatApiResponse, roistatApiError };
}

/**
 * Проверяет наличие roistat id и логирует ошибку, если его нет
 * @param errorCode - Код ошибки для логирования (например, "cartWithOutRoistat", "formWithOutRoistat")
 * @param additionalData - Дополнительные данные для логирования
 */
export async function checkAndLogRoistatId(
  errorCode: string,
  additionalData: Record<string, any> = {},
) {
  const roistatId = getRoistatId();

  if (!roistatId) {
    // Проверяем ответ от API roistat
    // const { roistatApiResponse, roistatApiError } = await checkRoistatApi();

    errorSent("formLogger", errorCode, {
      // @ts-ignore
      roistatId: null,
      // @ts-ignore
      windowRoistat:
        // @ts-ignore
        typeof window !== "undefined" && window.roistat
          ? // @ts-ignore
            JSON.stringify(window.roistat)
          : null,
      // @ts-ignore
      cookieRoistatVisit: getCookie("roistat_visit") || null,
      // @ts-ignore
      deviceInfo: getDeviceInfo(),
      // roistatApiResponse: roistatApiResponse
      //   ? JSON.stringify(roistatApiResponse)
      //   : null,
      // roistatApiError: roistatApiError ? JSON.stringify(roistatApiError) : null,
      timestamp: new Date().toISOString(),
      networkStatus: navigator.onLine ? "online" : "offline",
      roistatScript: !!document.querySelector('script[src*="roistat"]'),
      calltouchScript: !!document.querySelector('script[src*="calltouch"]'),
      ...additionalData,
    });
  }
}

/**
 * Функция для проверки roistat id с задержкой (возвращает cleanup функцию для использования в useEffect)
 * @param errorCode - Код ошибки для логирования
 * @param delay - Задержка перед проверкой в миллисекундах (по умолчанию 2000)
 * @param additionalData - Дополнительные данные для логирования
 * @returns Функция cleanup для очистки таймера
 */
export function checkRoistatIdWithDelay(
  errorCode: string,
  delay: number = 2000,
  additionalData: Record<string, any> = {},
) {
  if (typeof window === "undefined") {
    return () => {};
  }

  const timeoutId = setTimeout(() => {
    checkAndLogRoistatId(errorCode, additionalData);
  }, delay);

  return () => clearTimeout(timeoutId);
}
